<template>
  <top-bar :currentPage="currentPage" :icsType="'ics'">
    <div class="">
      <div class="intro-text" v-if="showIntro">{{ $t('main.INTRO') }}</div>
      <div class="search-bar-container">
        <tx-type-filter class="filter" :txType="txType" @change="updateTxType"></tx-type-filter>

        <district-dropdown
          class="filter"
          :selected-districts="filters.districts || []"
          @changeDistrict="updateDistrictFilterNoSearch"
        />

        <div class="autocomplete-container">
          <autocomplete-search
            :search-options="keywordsSeachOptions"
            :placeholder="$t('main.FREE_INPUT_TEXT')"
            @keywords-change="search"
            @keyword-input="updatePageFilter"
          />
        </div>

        <page-filter :keyword="keywordInput" :txType="txType" :districts="districts" />
      </div>
      <div class="suggest-bar">
        <div id="firsthand">
          <a :href="firstHandUrl">
            {{ $t('main.FIRST_HAND_STOCK') }}
          </a>
        </div>
        <div class="keyword" v-for="keyword in suggestKeywords" :key="keyword.value">
          <a :href="`${siteUrl}firsthand/details/${keyword.value}`">{{ keyword.suggestionWord }}</a>
        </div>
        <div class="more">
          <a :href="firstHandUrl">{{ $t('main.MORE') }}...</a>
        </div>
      </div>
    </div>
  </top-bar>
</template>

<script>
//import 'url-polyfill';
import { mapState, mapGetters, mapActions } from 'vuex';
import TopBar from '@/components/TopBar';
import PageFilter from '@/components/Home/Filters/Page';
import TxTypeFilter from '@/components/Stock/Filters/TxTypeFilter';
import DistrictDropdown from '@/components/Stock/Filters/DistrictDropdown';
import AutocompleteSearch from '@/components/Stock/AutocompleteSearch/DropdownInput';

export default {
  props: {
    showIntro: {
      default: () => false,
    },
    currentPage: {
      default: () => 'home',
    },
  },
  components: {
    TopBar,
    PageFilter,
    TxTypeFilter,
    DistrictDropdown,
    AutocompleteSearch,
  },
  data() {
    return {
      siteUrl: window.SITE_URL,
      icsType: 'ics',
      txType: [],
      keywordInput: null,
      selectedDistricts: [],
      districts: [],
      suggestKeywordsAll: {
        zh: [
          { suggestionWord: '沙咀道1號', type: 'building', value: 'B000100035', ics: 'c' },
          { suggestionWord: '威靈頓街92號', type: 'building', value: 'B000108713', ics: 's' },

          { suggestionWord: 'Ladder Dundas', type: 'building', value: 'B000088546', ics: 's' },
          { suggestionWord: '333 Hennessy', type: 'building', value: 'B000095756', ics: 'c' },
          { suggestionWord: 'NOVOJaffe', type: 'building', value: 'B000107092', ics: 'c' },
          { suggestionWord: '國際企業中心II期', type: 'building', value: 'B000093831', ics: 'i' },
        ],
        en: [
          { suggestionWord: '1 Sha Tsui Road', type: 'building', value: 'B000100035', ics: 'c' },
          {
            suggestionWord: '92 WELLINGTON STREET',
            type: 'building',
            value: 'B000108713',
            ics: 's',
          },

          { suggestionWord: 'Ladder Dundas', type: 'building', value: 'B000088546', ics: 's' },
          { suggestionWord: '333 Hennessy', type: 'building', value: 'B000095756', ics: 'c' },
          { suggestionWord: 'NOVOJaffe', type: 'building', value: 'B000107092', ics: 'c' },
          {
            suggestionWord: 'INTERNATIONAL ENTERPRISE CENTER II',
            type: 'building',
            value: 'B000093831',
            ics: 'i',
          },
        ],
      },
    };
  },
  mounted() {
    this.fetchDistricts();
  },
  watch: {
    'filters.districts': {
      handler(value) {
        if (value.length) {
          this.districts = value;
        } else {
          this.districts = [];
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapState('stocksAutocompleteSearch', {
      keywords: state => state.selectedKeywords,
      isFetchingAutocomplete: state => state.isFetching,
      isFetchedAutocomplete: state => state.isFetched,
    }),
    ...mapGetters('stocks', {
      filters: 'stockFilters',
    }),
    keywordsSeachOptions() {
      return {
        icsType: this.icsType,
      };
    },
    suggestKeywords() {
      return this.$i18n.locale === 'en' ? this.suggestKeywordsAll.en : this.suggestKeywordsAll.zh;
    },
    firstHandUrl() {
      return `${this.siteUrl}firsthand`;
    },
  },
  methods: {
    ...mapActions('districts', ['fetchDistricts']),
    ...mapActions('stocks', ['updateDistrictFilterNoSearch']),
    search() {
      let keywordSelected = '';
      if (this.keywords && this.keywords.length) {
        keywordSelected = this.keywords.reduce((a, k) => {
          if (a) {
            a = `${a},${encodeURIComponent(k)}`;
          } else {
            a = encodeURIComponent(k);
          }
          return a;
        }, '');
      }
      if (keywordSelected) {
        keywordSelected = `keywords=${keywordSelected}`;
      }

      let districtSelected = null;
      if (this.districts.length) {
        districtSelected = `districts=${this.districts.join(',')}`;
      }

      let txTypeSelected = '';
      if (this.txType.length) {
        if (this.txType.includes('L')) {
          txTypeSelected = `lease`;
        } else if (this.txType.includes('S')) {
          txTypeSelected = `sale`;
        }
      }

      let param = '';
      if (keywordSelected) {
        if (districtSelected) {
          param = `?${keywordSelected}&${districtSelected}`;
        } else {
          param = `?${keywordSelected}`;
        }
      }
      window.location.href = `${window.location.origin}${this.siteUrl}find/${txTypeSelected}${param}`;
    },
    updatePageFilter(val) {
      this.keywordInput = val;
    },
    updateTxType(val) {
      this.txType = val.txType;
    },
  },
};
</script>

<style scoped>
.intro-text {
  font-size: 18px;
  font-style: italic;
  font-weight: 500;
  line-height: 18px;
  white-space: nowrap;
  text-align: center;
}

.search-bar-container,
.suggest-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 5px;
}

.suggest-bar {
  margin-top: 8px;
}

.search-bar-container > div {
  flex: 0;
}

.search-bar-container > div + div {
  padding-left: 10px;
}

.search-bar-container > .autocomplete-container {
  flex: 1;
  max-width: 500px;
}

.search-bar-container > .intro-text + .autocomplete-container {
  max-width: 400px;
}

.suggest-bar > div + div {
  padding-left: 10px;
}

.suggest-bar > #firsthand {
  border-radius: 10px;
  background: #c60000;
  padding: 0 5px;
}

.suggest-bar > #firsthand > a {
  color: #fff;
}

.desktop-search-btn {
  background: #000000;
  color: #fee100;
  border-radius: 8px;
  font-size: 14px;
  width: 80px;
}
</style>
